export default __webpack_public_path__ + "static/media/clinica_medium.4aeb64bf.png";